
export enum PermissionAskStatus{
    asking = "asking",
    granted = "granted",
    denied = "denied",
    
}
export type askPanelFunctionCallback = (toAsk:boolean)=>void;
export type askPanelFunction = (result:IPermissionResult, callback:askPanelFunctionCallback)=>void;
export type askPermissionsBack = (stoped:boolean, granted:boolean, result?:IPermissionAskResult) =>void;
export interface IPermissionAskResult{
    isGranted:boolean
    status:PermissionAskStatus
    permissionResult?:IPermissionResult
    unsubListener?:()=>void
}
/**
 * Represents the result of a permission check operation
 */
export interface IPermissionResult {
    /**
     * Event name for permission check completion
     */
    completionEventName: string;
    
    /**
     * List of denied permission names
     */
    deniedPermissions: string[];
    
    /**
     * List of grant results
     */
    grantResults: IPermissionGrantResult[];
    
    /**
     * List of granted permission names
     */
    grantedPermissions: string[];
    
    /**
     * Name of the permission group
     */
    groupName: string;
    
    /**
     * Whether all requested permissions are granted
     */
    isAllGranted: boolean;
    
    /**
     * List of permissions that were permanently denied
     */
    permanentlyDeniedPermissions: string[];
    
    /**
     * List of all permissions that were requested
     */
    requestedPermissions: string[];
}

/**
 * Represents the result of a single permission grant request
 */
export interface IPermissionGrantResult {
    /**
     * The permission name
     */
    permission: string;
    
    /**
     * Grant result code (0 = granted, -1 = denied)
     */
    result: number;
    
    /**
     * Whether the permission was granted
     */
    isGranted: boolean;
    
    /**
     * Whether the permission was permanently denied
     */
    isPermanentlyDenied: boolean;
}

/**
 * Represents a permission group
 */
export interface IPermissionGroup {
    /**
     * The name of the permission group
     */
    name: string;
    
    /**
     * List of permissions in this group
     */
    permissions: string[];
    
    /**
     * Whether all permissions in this group are granted
     */
    isAllGranted: boolean;
}

/**
 * Represents the status of a permission check request
 */
export interface IPermissionCheckStatus {
    /**
     * The permission being checked
     */
    permission: string;
    
    /**
     * Whether the permission is granted
     */
    isGranted: boolean;
    
    /**
     * Whether the permission is permanently denied
     */
    isPermanentlyDenied: boolean;
    
    /**
     * The grant result code
     */
    grantResult: number;
}

/**
 * Represents a permission check request
 */
export interface IPermissionCheckRequest {
    /**
     * The permission to check
     */
    permission: string;
    
    /**
     * Optional message to show to the user
     */
    message?: string;
    
    /**
     * Whether to show a rationale if permission is denied
     */
    showRationale?: boolean;
}